"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCards = void 0;
require("rxjs");
var axios_1 = __importDefault(require("axios"));
var rxjs_1 = require("rxjs");
var storage_1 = require("../../utils/storage");
var operators_1 = require("rxjs/operators");
/**
 * Get Customer Cards
 * @param token
 */
function getCards(config) {
    var appEnvironment = config && config.environment != null ? config.environment : storage_1.getStorage('ENVIRONMENT');
    var customerToken = config && config.token ? config.token : storage_1.getStorage('TOKEN');
    var PAYMENTS_URL = "https://card-payments" + appEnvironment + ".cargosprintgroup.com";
    return rxjs_1.from(axios_1.default({
        method: 'GET',
        url: PAYMENTS_URL + '/customerCards',
        headers: { Authorization: "Bearer " + customerToken },
    })).pipe(operators_1.map(function (_a) {
        var data = _a.data;
        return data;
    }));
}
exports.getCards = getCards;
//# sourceMappingURL=getCreditCards.js.map